module.exports = __webpack_public_path__ + "img/biaoqian_fadianchang.6e29f46b.png";